// extracted by mini-css-extract-plugin
export default {"score-bars-container":"ScoreBars_score-bars-container__3eBKV","center":"ScoreBars_center__0Vws2","bar":"ScoreBars_bar__qXsBZ"};